import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';
var fonts = theme.fonts;
export var price = /*#__PURE__*/css(["font-family:", ";font-weight:", ";"], fonts.PRIMARY_SEMIBOLD.family, fonts.PRIMARY_SEMIBOLD.weight);
export var previous = /*#__PURE__*/css(["color:var(--neutral-black-70);text-decoration:line-through;"]);
export var sale = /*#__PURE__*/css(["color:var(--functional-red-base);"]);